'use strict';

var React = require('react');
require('prop-types');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');
var Button = require('../../node_modules/@material-ui/core/esm/Button/Button.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  inputButton: {
    display: 'none'
  },
  button: {
    marginLeft: 8
  }
};

function ImageUploadButton(_ref) {
  var classes = _ref.classes,
      handlePhotoUpload = _ref.handlePhotoUpload;
  return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement("input", {
    id: "banner-upload",
    accept: "image/*",
    type: "file",
    className: classes.inputButton,
    onChange: function onChange(event) {
      event.preventDefault();
      handlePhotoUpload(event);
      event.target.value = null;
    }
  }), React__default["default"].createElement("label", {
    htmlFor: "banner-upload"
  }, React__default["default"].createElement(Button["default"], {
    variant: "text",
    component: "span",
    color: "primary",
    className: classes.button
  }, "Custom image")));
}

var ImageUploadButton$1 = withStyles(styles)(ImageUploadButton);
ImageUploadButton.defaultProps = {
  handlePhotoUpload: function handlePhotoUpload() {}
};

module.exports = ImageUploadButton$1;
